export enum CommentsConstants {
  SET_COMMENT_TEXT = 'comments/SET_COMMENT_TEXT',
  SET_COMMENT_PAGE_TITLE = 'comments/SET_COMMENT_PAGE_TITLE',
  SET_COMMENT_MAX_LENGTH = 'comments/SET_COMMENT_MAX_LENGTH',
  SET_PREVIOUS_PAGE_PATH = 'comments/SET_PREVIOUS_PAGE_PATH',
  SET_ON_CHANGE_ACTION = 'comments/SET_ON_CHANGE_ACTION',
  SET_SAVE_ACTION = 'comments/SET_SAVE_ACTION',
  HIDE_COMMENTS = 'comments/HIDE_COMMENTS',
  CALL_SAVE_ON_CHANGE = 'comments/CALL_SAVE_ON_CHANGE',
  RESET_COMMENTS_STATE = 'comments/RESET_COMMENTS_STATE',
}
